import { useLocation, useNavigate } from "react-router-dom";

import {
  hasSummitTourLocationState,
  SHOW_TAKE_A_TOUR_TIP_LOCATION_STATE,
} from "../summitTour";

import { SummitProductTourModal } from "./SummitProductTourModal";

/** Opens the Summit product tour when navigated with `showSummitTour` location state. */
export const SummitProductTourHost = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const showTour = hasSummitTourLocationState(location.state);

  if (!showTour) {
    return null;
  }

  const clearTourState = (nextState: object = {}) => {
    navigate(".", { replace: true, state: nextState });
  };

  return (
    <SummitProductTourModal
      onClose={() => clearTourState()}
      onSkip={() => clearTourState(SHOW_TAKE_A_TOUR_TIP_LOCATION_STATE)}
    />
  );
};
